<template>
    <div class="login">
        <div class="rightBox">
            <div class="formBox">
                <h1>ברוך הבא</h1>
                <span>מערכת ניהול הזמנות פנימית</span>
                  <div v-if="wrongPassword" class="error">
                    {{wrongPassword}}
                  </div>
                <div class="inputField">
                    <label>שם משתמש</label>
                    <input type="text" v-model="LoginUser.username" @keydown="nameKeydown($event)" placeholder="שם המשתמש" @keyup.enter="signIn()">
                </div>
                <div class="inputField">
                    <label>סיסמה</label>
                    <input type="password" v-model="LoginUser.password" placeholder="********" @keyup.enter="signIn()">
                </div>
                <div class="inputField">
                    
                    <button @click="signIn()">כניסה למערכת</button>
                </div>
            </div>
        </div>
        <div class="leftBox">
            <img src="https://firebasestorage.googleapis.com/v0/b/greenhousecakes.appspot.com/o/orders%2Flogo.png?alt=media&token=c6db6348-f389-4dac-817e-63a0c5d69c2b" alt="">


<div class="area" >
            <ul class="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
    </div >
        </div>
    </div>

    <!-- <div class="signinContainer">

    <div class="logoImg">
            <img src="../../static/img/logo.png" alt="" >
          </div>


     <div class="loginRightBox">
      <div class="topImgNav">
        <img src="../../static/img/logo.png" alt="">
      </div>
      <div class="signInBox">

      </div>
    </div>
    <div class="loginLeftBox"></div> 
        <div class="signUpBox">
          
          <h1>כניסה למערכת</h1>
            <div class="input-field">
              <label> שם המשתמש</label>
              <input type="text" v-model="LoginUser.username" placeholder="שם המשתמש" @keyup.enter="signIn()">
            </div>
            <div class="input-field">
              <label>סיסמה</label>
              <input type="password" v-model="LoginUser.password" placeholder="********" @keyup.enter="signIn()">
            </div>

            <div class="input-field">
              <button @click="signIn()" >כניסה</button>
            </div>
        </div>

         <div class="signUpBox">
          
          <h1>הרשמה למערכת</h1>
            <div class="input-field">
              <label> דואר אלקטרוני</label>
              <input type="text" v-model="workerName" placeholder="name">
            </div>
            <div class="input-field">
              <label> דואר אלקטרוני</label>
              <input type="text" v-model="email" placeholder="mail@example.com">
            </div>
            <div class="input-field">
              <label>סיסמה</label>
              <input type="password" v-model="password" placeholder="********" @keyup.enter="signUp()">
            </div>

            <div class="input-field">
              <button @click="signUp()" >הרשמה</button>
            </div>
        </div> 
   </div>  -->
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../firebase";
export default {
  name: 'SignIn',
  props :['item', 'rowIndex'],
  data () {
    return {
        // workerName :'',
        LoginUser:{
          username:'',
          password: "",
        },
        wrongPassword : "",
        name: "",

    }
  },created(){
    let vm  = this ;
    if(vm.$root.loggedUser != null ){
          
          vm.$router.push("/Home");
        }
        else{
          vm.$router.push("/");
        }
    },
    watch: {
    name(val) {
      this.name = val.replace(/\W/g, "");
    },
  },
  methods : {
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    signIn(){
      let vm = this;
      db.collection("Users").where("username", "==", vm.LoginUser.username).limit(1).get()
      .then((result) => {
        if(result.size > 0){
          result.forEach((doc) => {
            let user = doc.data();
            if(user.password == vm.LoginUser.password){
              vm.$root.loggedUser = doc.data();
              vm.$root.loggedUser.password = '*********';
              // if(!user.active){
              //   user.active = true;
              //   vm.$root.isAuth = user.active
              // }
              // vm.$root.getUserData();
              console.log("$root : ", vm.$root.isAuth)
              console.log("is the user active? ", user.active)
              localStorage.setItem("User", JSON.stringify(vm.$root.loggedUser ));
              // localStorage.setItem("UserID", JSON.stringify(vm.$root.loggedUser.userID ));
              if(vm.$root.loggedUser.Type === "Admin"){
                vm.$router.push("/Home")
              }
              if(vm.$root.loggedUser.Type === "Manager"){
                vm.$router.push("/Orders")
              }
              if(vm.$root.loggedUser.Type === "Worker"){
                vm.$router.push("/Orders")
              }

            }else{
                // alert("סיסמה שגויה");
                vm.wrongPassword = "שם משתמש או סיסמה שגויים!";
              }
          })
        }else{
          alert("משתמש אינו קיים")
        }
        
      }).catch((err) => {
            console.log("Error : ");
          
          });

    },
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@400;500;600;700;800;900&display=swap');

*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Noto Sans Hebrew';
}
.login{
    /* display: flex; */
    direction: rtl;
    /* margin-right: -300px; */
}
.rightBox{
    width: 50%;
    min-height: 100vh;
    float: right;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.leftBox{
    width: 50%;
    float: right;
    background-color: #00693E;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.leftBox img{
    width: 40%;
}
.rightBox .formBox{
    width: 60%;
    min-height: 100px;
    background-color: #fff;
    padding: 1rem;
    text-align: center;
}
.formBox h1{
    color: #1c1c1c;
    font-size: 25px;
}
.formBox span{
    color: #666;
    font-size: 13px;
    margin-bottom: 1rem;
}
.formBox .inputField{
    text-align: center;
    min-height: 40px;
    width: 100%;
    margin-top: 0.5rem;
    position: relative;
}
.formBox .inputField label{
    color: #666;
    font-size: 13px;
    font-weight: 400;
    display: block;
    text-align: right;
    margin-bottom: 3px;
}
.formBox .inputField input{
    color: #666;
    font-size: 13px;
    font-weight: 400;
    display: block;
    text-align: right;
    width: 100%;
    height: 42px;
    border: 1px solid #e0e0e0;
    padding-right: 10px;
    border-radius: 8px;
}
.formBox .inputField input:hover,
.formBox .inputField input:focus
{
    outline: none;
    background-color: #f5f5f5;
    transition: 0.3s;
}
.formBox .inputField button{
    color: #fff;
    font-size: 13px;
    font-weight: 400;
    display: block;
    text-align: center;
    width: 40%;
    height: 42px;
    border: 1px solid #00693E;
    border-radius: 8px;
    position: absolute;
    left: 0rem;
    background-color: #00693E;
}
.formBox .inputField button:hover{
    opacity: 0.8;
    cursor: pointer;
}
.error{
    background-color: aliceblue;
    padding: 10px 10px;
    margin-top: 1rem;
    border-right: 6px solid #c62828;
    font-size: 14px;
    font-weight: 500;
    text-align: right;
    color: #c62828;
    border-radius: 5px;
}

.area{
    height:100vh;
}

.circles{
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
}

.circles li{
    position: absolute;
    display: block;
    list-style: none;
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
    animation: animate 25s linear infinite;
    bottom: -150px;
    
}

.circles li:nth-child(1){
    left: 25%;
    width: 80px;
    height: 80px;
    animation-delay: 0s;
}


.circles li:nth-child(2){
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 2s;
    animation-duration: 12s;
}

.circles li:nth-child(3){
    left: 70%;
    width: 20px;
    height: 20px;
    animation-delay: 4s;
}

.circles li:nth-child(4){
    left: 40%;
    width: 60px;
    height: 60px;
    animation-delay: 0s;
    animation-duration: 18s;
}

.circles li:nth-child(5){
    left: 65%;
    width: 20px;
    height: 20px;
    animation-delay: 0s;
}

.circles li:nth-child(6){
    left: 75%;
    width: 110px;
    height: 110px;
    animation-delay: 3s;
}

.circles li:nth-child(7){
    left: 35%;
    width: 150px;
    height: 150px;
    animation-delay: 7s;
}

.circles li:nth-child(8){
    left: 50%;
    width: 25px;
    height: 25px;
    animation-delay: 15s;
    animation-duration: 45s;
}

.circles li:nth-child(9){
    left: 20%;
    width: 15px;
    height: 15px;
    animation-delay: 2s;
    animation-duration: 35s;
}

.circles li:nth-child(10){
    left: 85%;
    width: 150px;
    height: 150px;
    animation-delay: 0s;
    animation-duration: 11s;
}



@keyframes animate {

    0%{
        transform: translateY(0) rotate(0deg);
        opacity: 1;
        border-radius: 0;
    }

    100%{
        transform: translateY(-1000px) rotate(720deg);
        opacity: 0;
        border-radius: 50%;
    }

}
@media screen and (max-width:500px){
  .login {
    display: flex;
    direction: rtl;
    margin-right: 0;
}
  .rightBox{
    width: 100%;
    min-height: 100vh;
    float: right;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.rightBox .formBox{
    width: 90%;
    min-height: 100px;
    background-color: #fff;
    padding: 1rem;
    text-align: center;
}
.leftBox{
    display: none;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/signIn.vue